import { Workspace } from '@anm/api/modules/team';
import BuiltInDropdown from '@anm/components/BuiltInDropdown';
import { useEffect, useState, FC } from 'react';

import DropdownItem from './DropdownItem';
import Wrapper from './Wrapper';

type WorkspaceInfo = { workspace: Workspace; title?: string; avatar?: string };
export type ChangeWorkspaceDropdownProps = {
  workspacesInfoList: WorkspaceInfo[];
  currentWorkspace: Workspace;

  className?: string;
  onWorkspaceChange: (newWorkspace: Workspace) => void;
};

export const defaultAvatar = 'images/avatar-placeholder.svg';

const ChangeWorkspaceDropdown: FC<ChangeWorkspaceDropdownProps> = ({
  className,
  workspacesInfoList,
  currentWorkspace: newCurrentWorkspace,
  onWorkspaceChange
}) => {
  const [currentWorkspace, setCurrentWorkspace] = useState<Workspace>(newCurrentWorkspace);

  const { currentWorkspaceInfo, leftWorkspacesInfoList } = workspacesInfoList.reduce(
    (acc, item) => {
      if (currentWorkspace === item.workspace) {
        acc.currentWorkspaceInfo = item;
      } else {
        acc.leftWorkspacesInfoList.push(item);
      }

      return acc;
    },
    { currentWorkspaceInfo: {} as WorkspaceInfo, leftWorkspacesInfoList: [] as WorkspaceInfo[] }
  );

  const changeWorkspace = (workspace: Workspace) => {
    setCurrentWorkspace(workspace);
    onWorkspaceChange(workspace);
  };

  useEffect(() => {
    setCurrentWorkspace(newCurrentWorkspace);
  }, [newCurrentWorkspace]);

  return (
    <Wrapper>
      <BuiltInDropdown
        autoClose={true}
        className={className}
        maxWindowHeight={300}
        renderContent={({ closeDropdown }) => (
          <>
            {leftWorkspacesInfoList.map(({ workspace, avatar, title }) => (
              <DropdownItem
                title={title}
                avatar={avatar}
                workspace={workspace}
                onClick={workspace => {
                  closeDropdown();
                  changeWorkspace(workspace);
                }}
              />
            ))}
          </>
        )}
      >
        <DropdownItem
          title={currentWorkspaceInfo.title}
          avatar={currentWorkspaceInfo.avatar}
          workspace={currentWorkspace}
        />
      </BuiltInDropdown>
    </Wrapper>
  );
};

export default ChangeWorkspaceDropdown;
